





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import Placeholder from '@/views/account/Placeholder.vue';
import MegacardStore from '@/stores/user/megacard.store';
import { MegacardRequestDto } from '@/api';
import ErrorKey from '@/util/ErrorKey';
import SmoothShow from '@/views/common/SmoothShow.vue';
import { MegacardRequestState } from '@/util/megacard-connector-models';
import VueI18n from 'vue-i18n';

@Component({
  components: {SmoothShow, Placeholder, LoadingIndicator},
})
export default class RegisterMegacardSelector extends Vue {
  @Prop({required: true})
  public readonly messageSpace!: string;
  public states = MegacardRequestState;
  public state = MegacardRequestState.NOT_SUBMITTED;
  public number = '';
  public postCode = '';
  private megacardStore = getModule(MegacardStore, this.$store);
  private successName = '';

  get loading(): boolean {
    return this.state === MegacardRequestState.LOADING;
  }

  public async handleSubmit(): Promise<void> {
    if (this.state === MegacardRequestState.SUCCESS) {
      this.removeConnection();
    } else {
      return this.requestConnect();
    }
  }

  private async requestConnect(): Promise<void> {
    if (!this.number || !this.postCode) {
      this.state = MegacardRequestState.NOT_FOUND;
      return;
    }
    const request: MegacardRequestDto = {
      number: this.replaceWhiteSpace(this.number),
      postCode: this.replaceWhiteSpace(this.postCode),
    };
    this.state = MegacardRequestState.LOADING;
    this.megacardStore.resetRequestedMegacard();
    const response = await this.megacardStore.previewMegacardData(request);
    if (response.success) {
      this.state = MegacardRequestState.SUCCESS;
    } else if (response.error?.errorKey === ErrorKey.NoSuchMegacardException) {
      this.state = MegacardRequestState.NOT_FOUND;
    } else {
      this.state = MegacardRequestState.ERROR;
    }
    this.$emit('change', response.payload);
    this.successName = response.payload?.firstName ?? '';
  }

  private removeConnection(): void {
    this.state = MegacardRequestState.NOT_SUBMITTED;
    this.megacardStore.resetRequestedMegacard();
    this.$emit('change', undefined);
  }

  private translateNamespaced(keyPart: string, args?: any): VueI18n.TranslateResult {
    return this.$t('message.userData.megaCard.' + this.messageSpace + '.' + keyPart, args);
  }

  private replaceWhiteSpace(value: string) {
    return value.replace(/\s/g, '');
  }
}
